import React from 'react';
import moment from 'moment';

export default function CustomLabel(props) {
  const { value, dataType, suffix, prefix} = props;
  let dataValue = value;
  if (dataValue && dataType) {
    dataValue = moment(dataValue).format(dataType);
  }
  if (dataValue && suffix) {
    dataValue = `${dataValue}${suffix}`;
  }
  if (dataValue && prefix) {
    dataValue = `${prefix}${dataValue}`;
  }
  return <label className="manage-subs-custom-label custom-form-item-value">{dataValue}</label>;
}
export function CustomLabelWithValue(props) {
 
    const { value, suffix, prefix, name, itemVal } = props;
    let dataValue = (itemVal !== undefined && itemVal !== null && itemVal !== '') ? itemVal : value;
    if(name === "originalAsoh") {
      return (
        <>
          <label className="custom-form-item-value" style={{color:'#0071bc'}}>{dataValue}</label>
          <label className="custom-form-item-value" >{suffix}</label>
        </>
      )
    }else if(name === "originalPrice") {
      dataValue && prefix && (dataValue = `${prefix}${dataValue}`)
      return (
        <label className="custom-form-item-value" style={{color:'#db930b'}}>{dataValue}</label>
      );
    }else {
      dataValue && suffix && (dataValue = `${dataValue}${suffix}`)
      dataValue && prefix && (dataValue = `${prefix}${dataValue}`)
      return (
        <label className="custom-form-item-value">{dataValue}</label>
      );
    }
  }

